import type { ID } from '@octopus-do/octopus-project-core'
import { uiReleaseLocks, uiSetLocks } from '@storeOld/reducers/ui'
import type { Task } from 'redux-saga'
import { cancel, delay, fork, put } from 'redux-saga/effects'

import type { InternalActions } from '../actions'

const AUTORELEASE_TIMEOUT = 60 * 1000

const releaseTasks: Record<ID, Task> = {}

function* autoRelease(id: string) {
  yield delay(AUTORELEASE_TIMEOUT)
  yield put(uiReleaseLocks([id]))
}

export function* setLock({
  payload: { id, initiatorId },
}: ReturnType<typeof InternalActions.setLock>) {
  // todo: multiple types
  yield put(uiSetLocks({ [id]: initiatorId }))

  const prevTask = releaseTasks[id]

  if (prevTask) {
    yield cancel(prevTask)
  }

  releaseTasks[id] = yield fork(autoRelease, id)
}
